import React from 'react';
import { patientsCanSkip } from '../hooks/usePatientsTour';

/**
 * PatientsJoyrideTooltip is the custom tooltip renderer used by react-joyride
 * in the Pacientes onboarding tour — mismo estilo que SessionsJoyrideTooltip.
 */

type Props = {
  index: number;
  size: number;
  step?: { content?: React.ReactNode };
  backProps: Record<string, unknown>;
  primaryProps: Record<string, unknown>;
  skipProps: Record<string, unknown>;
  tooltipProps: Record<string, unknown>;
};

export const PatientsJoyrideTooltip: React.FC<Props> = ({
  index,
  size,
  step,
  backProps,
  primaryProps,
  skipProps,
  tooltipProps,
}) => {
  const total = Number(size) || 0;
  const current = Number(index) + 1;
  const isLast = current >= total && total > 0;
  const nextLabel = isLast ? 'Entendido' : `Continuar (${current} de ${total})`;

  return (
    <div
      {...tooltipProps}
      style={{
        ...(tooltipProps.style as React.CSSProperties | undefined),
        background: '#fff',
        borderRadius: 12,
        boxShadow: '0 10px 25px rgba(0,0,0,0.15)',
        maxWidth: 420,
        padding: '1rem 1rem 0.75rem 1rem',
        color: '#111827',
      }}
    >
      <div style={{ marginBottom: '0.75rem' }}>{step?.content}</div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem', paddingTop: '0.25rem' }}>
        <button
          {...primaryProps}
          className="btn-primary"
          style={{ height: 32, fontSize: '0.875rem', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', padding: '0 14px', whiteSpace: 'nowrap', lineHeight: '32px' }}
        >
          {nextLabel}
        </button>
        {index > 0 && (
          <button {...backProps} className="btn-outline" style={{ height: 32 }}>
            Atrás
          </button>
        )}
      </div>
      {patientsCanSkip && (
        <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '0.5rem' }}>
          <button
            {...skipProps}
            style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: '0.9rem', fontFamily: 'inherit', fontWeight: 700 }}
          >
            Saltar
          </button>
        </div>
      )}
    </div>
  );
};

export default PatientsJoyrideTooltip;
